"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8522],{

/***/ 8522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionDoubleMediaWithBackground": function() { return /* binding */ SectionDoubleMediaWithBackground; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    display: "grid",
    gap: "$96",
    containerSpace: "none",
    "@lg": {
        gridTemplateColumns: "1fr 1fr",
        gap: "$32",
        containerSpace: "medium"
    }
});
const CardWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$20"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    projectFont: "body04",
    color: "$black_06"
});
const DescriptionContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    containerSpace: "medium",
    "@lg": {
        containerSpace: "none"
    }
});
const SectionDoubleMediaWithBackground = (param)=>{
    let { color , priority , mediaCards  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSectionWrapper, {
        type: "MEDIA",
        children: mediaCards === null || mediaCards === void 0 ? void 0 : mediaCards.map((card, index)=>{
            var _card_media;
            return ((_card_media = card.media) === null || _card_media === void 0 ? void 0 : _card_media.mediaPayload) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardWrap, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .MediaWithBackground */ .xu, {
                        media: card.media,
                        color: color,
                        priority: priority,
                        mediaBorder: card.mediaBorder,
                        sizes: "(min-width: 1000px) 50vw, 100vw",
                        appearance: "doubleMedia"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DescriptionContainer, {
                        children: card.mediaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Description, {
                            children: [
                                "↑ ",
                                card.mediaDescription
                            ]
                        })
                    })
                ]
            }, "media-".concat(card.mediaDescription, "-").concat(index));
        })
    });
};


/***/ })

}]);